import Vue from "vue";
import App from "./App.vue";
import Debug from "./debug.js";

window.EpoqNS = window.EpoqNS || {};
window.EpoqNS.EventBus = new Vue();
Vue.prototype.$bus = window.EpoqNS.EventBus;

const $ = window.jQuery;
let giftListInited = false;

// NOTE: naming convention hint
// concerning giftfinder "giftlist" is used while "wishlist" is used for shop-derived wishlist

window.EpoqNS.epoqGiftListForeignInit = function (epoqData) {
	setDegugMode();
	try {
		if (giftListInited) {
			Debug.log("Gift list already initialized. Params are updated.");
			window.EpoqNS.EventBus.$emit("epoqUrlChange", epoqData);
			return;
		}

		const giftListTimeout = sessionStorage.getItem("epoqGLTimeout");

		if (giftListTimeout) {
			setTimeout(() => {
				initGiftList(epoqData);
			}, parseInt(giftListTimeout));
		} else {
			initGiftList(epoqData);
		}

		giftListInited = true;
	} catch (e) {
		Debug.log("error during giftlist init", e, 1);
	}
};

window.EpoqNS.getIconPath = function (icon) {
	let iconPath = "/Icons/iconSprite.svg";
	/*
	const $refIcon = document.querySelector(
		'[class^="BasketWidgetButton"] svg use[*|href], [class^="BasketIcon"] svg use[*|href], [class^="LabelDisplayerStyled"] svg use[*|href], [class^="BreadcrumbScroller"] svg use[*|href]'
	);

	if ($refIcon && $refIcon.getAttribute("xlink:href")) {
		iconPath = $refIcon.getAttribute("xlink:href").split("#")[0];
	}
*/

	return iconPath + "#" + (icon || "");
};

function initGiftList(epoqData) {
	const giftListObj = {
		lang: "de",
		// partnerId: "11296AA4-0F22-4EC0-B5D0-20830C1090A7",
		partnerId: "E5787F48-9053-4187-978C-5085ED6B6D36",
		isLoggedUser:
			epoqData.userState && epoqData.userState === "authentificated",
		customerId: epoqData.cid || "",
		giftFinderUrl:
			window.location.origin + "/de/inspirations-welt/geschenkefinder/",
		isGiftFinderPage: false,
		wishListUrl: "/de/merkliste/",
		isWishListPage: false,
		giftListId: "",
		giftListName: "Geschenkeliste",
		giftList: [],
		giftListPids: [],
		storageKey: "eq_gl",
		storageKeyDisplay: "eq_gl_display",
		getGiftListJson: getGiftListJson,
		mapGiftListItems: mapGiftListItems,
		addToRemoteGiftList: addToRemoteGiftList,
		removeFromRemoteGiftList: removeFromRemoteGiftList,
		clearRemoteGiftList: clearRemoteGiftList,
		decreaseWishListCounter: decreaseWishListCounter,
		setWishListCounter: setWishListCounter,
		navigateToUrl: navigateToUrl,
		getIconPath: getIconPath,
		clearEcommerceObject: clearEcommerceObject,
		isMobile: false,
		setClubModalUrl:
			window.setClubModalUrl ||
			function () {
				Debug.log("function setClubModalUrl not defined.");
			},
		triggerClubModal: triggerClubModal,
		addToCart: addToCart,
	};
	const callbacks = epoqData.callBackObject;

	try {
		handleCurrentPage(epoqData, true);

		window.EpoqNS.EventBus.$on("epoqUrlChange", (epoqData) => {
			setTimeout(() => {
				handleCurrentPage(epoqData, false);
			}, 100);
		});
	} catch (e) {
		Debug.log("error getting customer ID", e, 1);
	}

	function isGiftFinderPage() {
		return (
			window.location.pathname === "/de/inspirations-welt/geschenkefinder/"
		);
	}

	function isGiftFinderActive() {
		return !!document.querySelector(
			"#epoq_giftFinderModal #epoq_widget.active",
		);
	}

	function isWishListPage() {
		return window.location.pathname.indexOf(giftListObj.wishListUrl) !== 0;
	}

	function updateGiftListParams(epoqData) {
		giftListObj.isLoggedUser =
			epoqData.userState && epoqData.userState === "authentificated";
		giftListObj.customerId = epoqData.cid || "";
		giftListObj.isGiftFinderPage = isGiftFinderPage();
		giftListObj.isWishListPage = isWishListPage();
		giftListObj.isMobile = isMobileViewport();
	}

	function handleViewportResize() {
		window.removeEventListener("resize", _checkMobile);
		window.addEventListener("resize", _checkMobile);

		function _checkMobile() {
			giftListObj.isMobile = isMobileViewport();
		}
	}

	function handleCurrentPage(epoqData, initial) {
		const lastLoginState = giftListObj.isLoggedUser;

		updateGiftListParams(epoqData);
		handleViewportResize();

		if (giftListObj.isGiftFinderPage) {
			window.localStorage.setItem(giftListObj.storageKeyDisplay, "true");
			// injectDemoButton();
		} else {
			handleShopAddToWishList();
			handleShopRemoveFromWishList();
			// handleShopClearWishList(); // NOTE: currently included in handleShopRemoveFromWishList
		}

		getCustomerId().then((response) => {
			// response.text().then(cid => {
			const cid = response;
			Debug.log("cid: ", cid, 1);
			giftListObj.customerId = cid;

			handleWishListPage();
			handleLogout();
			handleGiftList(initial, lastLoginState !== giftListObj.isLoggedUser);
			// });
		});
	}

	async function getCustomerId() {
		// if (typeof window.getCId === "function") {
		// 	const cid = await window.getCId();
		// 	Debug.log("cid -> ", cid, 1);
		// 	return cid || "";
		// }

		// TODO: !!! get customerId
		return Promise.resolve(giftListObj.customerId);
		// return await fetch("/de/getCId", {
		// 	headers: {
		// 		"content-type": "text/plain;charset=ISO-8859-1"
		// 	},
		// 	referrerPolicy: "same-origin",
		// 	method: "POST",
		// 	mode: "cors"
		// });
	}

	function handleWishListPage() {
		giftListObj.isWishListPage = isWishListPage();
	}

	function handleLogout() {
		$(document).off(
			"click.epoqGL",
			'button[data-cy="modal-account-button-logout"], button[data-cy="welcome-nav-logoutButton"]',
		);
		$(document).on(
			"click.epoqGL",
			'button[data-cy="modal-account-button-logout"], button[data-cy="welcome-nav-logoutButton"]',
			function () {
				window.EpoqNS.EventBus.$emit("epoqCloseGiftList");
				clearGiftListStorage();
				giftListObj.giftList = [];
			},
		);
	}

	function handleGiftList(inital, sync) {
		getMappedGiftListItems().then((mappedGiftListItems) => {
			Debug.log("mappedGiftListItems", mappedGiftListItems, 1);
			giftListObj.giftList = mappedGiftListItems;

			if (
				inital &&
				(!giftListObj.isWishListPage || !giftListIsCurrentWishListPage())
			) {
				initGiftList();
			} else {
				triggerRefreshGiftList(sync);
			}

			if (giftListObj.isGiftFinderPage) {
				setIdForGiftListUrl();
			}
		});
	}

	function giftListIsCurrentWishListPage() {
		return (
			window.document.querySelector(
				'ul > li > a.on[href="' + giftListObj.wishListUrl.slice(0, -1) + '"]',
			) !== null
		);
	}

	function setIdForGiftListUrl() {
		const $giftListIconInHead = document.querySelector(
			'.epoq_icon_wrapper[data-link="/merkliste"]',
		);

		if (!$giftListIconInHead || !giftListObj.giftListId) {
			return;
		}

		const giftListUrl = $giftListIconInHead.getAttribute("data-link");
		$giftListIconInHead.setAttribute(
			"data-link",
			giftListUrl + "/" + giftListObj.giftListId + "/",
		);
	}

	function injectDemoButton() {
		let target = document.createElement("BUTTON");
		target.id = "epoq-giftlist-demo-btn";
		target.innerHTML = giftListObj.giftListName + "-Demo";

		let isDemo = window.localStorage.getItem(giftListObj.storageKeyDisplay);

		if (isDemo === "true") {
			target.classList.add("is--active");
		}

		target.addEventListener("click", function () {
			window.localStorage.setItem(
				giftListObj.storageKeyDisplay,
				isDemo !== "true",
			);
			window.location.reload();
		});

		window.document.body.appendChild(target);
	}

	async function getMappedGiftListItems() {
		return await getGiftList().then((giftListItems) => {
			return mapGiftListItems(giftListItems);
		});
	}

	async function getGiftList() {
		giftListObj.giftListPids = await getGiftListPids();
		const giftListResponse = await getGiftListJson(giftListObj.giftListPids);

		return giftListResponse.ProductTiles || [];
	}

	async function getGiftListPids() {
		// TODO: use correct user login check
		if (giftListObj.isLoggedUser) {
			return await getGiftListPidsFromRemote();
		} else {
			return await getGiftListPidsFromStorage();
		}
	}

	async function getGiftListPidsFromRemote() {
		let remoteGiftListIems = [];

		customDebugLog(
			"calling callbackGetWishlist for " + giftListObj.giftListName,
		);

		await _getRemoteWishlist();

		async function _getRemoteWishlist() {
			await callbacks
				.callbackGetWishlist(giftListObj.giftListName)
				.then(async (data) => {
					customDebugLog("callbackGetWishlist result", data, 1);

					giftListObj.giftListId =
						(data && data.wishlist && data.wishlist.WishlistId) || "";

					// NOTE: remember giftListId for search
					EpoqNS.giftListId = giftListObj.giftListId;

					remoteGiftListIems =
						(data && data.productIdsWholeList) || remoteGiftListIems;
				});
			Debug.log("remote giftlist", remoteGiftListIems, 1);
		}

		return remoteGiftListIems;
	}

	async function getGiftListPidsFromStorage() {
		return JSON.parse(
			window.localStorage.getItem(giftListObj.storageKey) || "[]",
		)
			.filter((item) => {
				return item && item.productId;
			})
			.reduce((acc, curr) => {
				acc.push(curr.productId);
				return acc;
			}, []);
	}

	function updateGiftListStorage(mappedGiftListItems) {
		window.localStorage.setItem(
			giftListObj.storageKey,
			JSON.stringify(mappedGiftListItems || "[]"),
		);
	}

	function clearGiftListStorage() {
		window.localStorage.removeItem(giftListObj.storageKey);
	}

	function getGiftListJson(giftListPids) {
		if (!giftListPids || !giftListPids.length) {
			return [];
		}

		let subdomain = "pic";

		// NOTE: set proper tile request url
		// test -> "https://t-pic.exlibris.ch/v1/Product/ProductTileQuery/"
		// acceptance -> "https://a-pic.exlibris.ch/v1/Product/ProductTileQuery/"
		// prod -> "https://pic.exlibris.ch/v1/Product/ProductTileQuery/"
		switch (location.hostname) {
		/* eslint-disable */
			case "t-www.exlibris.ch":
				subdomain = "t-" + subdomain;
				break;
			case "a-www.exlibris.ch":
				subdomain = "a-" + subdomain;
				break;
		}
		/* eslint-enable */

		return fetch(
			"https://" + subdomain + ".exlibris.ch/v1/Product/ProductTileQuery/",
			{
				headers: {
					"content-type": "application/json",
				},
				referrerPolicy: "same-origin",
				body: JSON.stringify({
					PartnerId: giftListObj.partnerId,
					Language: giftListObj.lang,
					CID: giftListObj.customerId,
					TileId: 77,
					// TileId: 80,
					PageCharacter: "Geschenkefinder",
					// PageCharacter: "Wish List",
					Eans: giftListPids,
				}),
				method: "POST",
				mode: "cors",
			},
		)
			.then((response) => response.json())
			.then((data) => {
				// Here's a list of repos!
				Debug.log("Wish List data", data, 1);
				return data;
			})
			.catch((e) => {
				Debug.log("error during product tile service request", e, 1);
				return [];
			});
	}

	function mapGiftListItems(wishListItems) {
		const mappedItems = [];

		if (!wishListItems.length) {
			return [];
		}
		Debug.log("wishListItems", wishListItems, 1);

		try {
			wishListItems.map((item) => {
				const icons = _getIconsData(item.Icons || []);
				const obj = {
					productId: item.Ean,
					title: item.Slot1,
					author: item.Slot2,
					description: item.Slot3,
					releaseDate: item.Slot4,
					category: item.Slot5,
					image: item.Cover.Url,
					altText: item.Cover.AltText,
					link: item.Cover.Link,
					price: item.Price.Sales || item.Price.List,
					oldprice: item.Price.List,
					currency: item.Price.Currency,
					availability: item.Availability.Text || "",
					availabilityColor: item.Availability.Color || "green",
					badgeCount: item.Icons.length || 0,
					discount: icons.default.text1,
					discountColor: icons.default.color,
					// TODO: get club info
					club: icons.diamond.enabled,
					clubDiscount: item.ClubDiscount || "",
					clubMember: icons.clubMember.enabled,
					clubMemberDiscount: icons.clubMember.text1,
					clubMemberDiscountText: icons.clubMember.text2,
					lowPrice: icons.lowPrice.text1,
					lowPriceColor: icons.lowPrice.color,
					loveState: item.LoveState || "0",
					comment: item.Comment || "",
				};
				mappedItems.push(obj);
			});
		} catch (e) {
			Debug.log("error mapping wishlist items", wishListItems, 1);
		}

		function _getIconsData(icons) {
			const typeMap = [
				"default",
				"defaultVOD",
				"diamond",
				"clubMember",
				"lowPrice",
			];
			const iconsData = {
				default: {
					enabled: false,
					color: "",
					text1: "",
					text2: "",
				},
				defaultVOD: {
					enabled: false,
					color: "",
					text1: "",
					text2: "",
				},
				diamond: {
					enabled: false,
					color: "",
					text1: "",
					text2: "",
				},
				clubMember: {
					enabled: false,
					color: "",
					text1: "",
					text2: "",
				},
				lowPrice: {
					enabled: false,
					color: "",
					text1: "",
					text2: "",
				},
			};

			if (!icons.length) {
				return iconsData;
			}

			icons.map((icon) => {
				if (
					icon.hasOwnProperty("Type") &&
					(icon.Type === 0 ||
						icon.Type === 1 ||
						icon.Type === 2 ||
						icon.Type === 3 ||
						icon.Type === 4)
				) {
					let typeName = typeMap[icon.Type];
					iconsData[typeName].enabled = true;
					iconsData[typeName].color = icon.Color || "";
					iconsData[typeName].text1 = (icon.Text1 || "").replace(".00", "");
					iconsData[typeName].text2 = icon.Text2 || "";
				}
			});

			return iconsData;
		}

		return mappedItems;
	}

	async function addToRemoteGiftList(productId) {
		Debug.log("calling callbackAddToWishlist with ean: " + productId);
		customDebugLog(
			"calling callbackAddToWishlist with ean: " +
				productId +
				", WishlistName: " +
				giftListObj.giftListName,
		);
		let result = await callbacks
			.callbackAddToWishlist(productId, giftListObj.giftListName)
			.then((result) => {
				Debug.log("callbackAddToWishlist result", result, 1);
				customDebugLog("callbackAddToWishlist result", result, 1);
				return result;
			})
			.catch((result) => false);
		return result;
	}

	async function removeFromRemoteGiftList(productId) {
		customDebugLog(
			"calling callbackRemoveFromWishlist with ean: " +
				productId +
				", WishlistName: " +
				giftListObj.giftListName,
		);

		let result = await callbacks
			.callbackRemoveFromWishlist(productId, giftListObj.giftListName)
			.then((result) => {
				Debug.log("callbackRemoveFromWishlist result", result, 1);
				customDebugLog("callbackRemoveFromWishlist result", result, 1);
				// TODO: check if icon handle is required
				// $(".m-add-to-wishlist").css("opacity", "0");
				Debug.log("removed from remote wishlist -> " + productId);
				// decreaseWishListCounter(); // NOTE: disabled as handled by Nexum
				return result;
			})
			.catch((result) => false);
		return result;
	}

	async function clearRemoteGiftList() {
		customDebugLog(
			"calling callbackClearWishlist for " + giftListObj.giftListName,
		);

		let result = await callbacks
			.callbackClearWishlist(giftListObj.giftListName)
			.then((result) => {
				customDebugLog("callbackClearWishlist result", result, 1);
				Debug.log(result);
				// TODO: check if icon handle is required
				// $(".m-add-to-wishlist").css("opacity", "0");
				Debug.log("remote wishlist cleared result", result, 1);
				// decreaseWishListCounter(); // NOTE: disabled as handled by Nexum
				return result;
			})
			.catch((result) => false);
		return result;
	}

	function decreaseWishListCounter(resetCounter) {
		// NOTE: disabled as handled by Nexum
		/*
		// NOTE: do not change wish list badge value in shop
		if (!isGiftFinderPage()) {
			return;
		}

		const $wishListQuantity = $("#Service-Navi_Wishlist").children(".qty-1");
		const value = resetCounter
			? 0
			: parseInt($wishListQuantity.text() || "1") - 1;

		$wishListQuantity.text(value);
		*/
	}

	function setWishListCounter(value) {
		// NOTE: disabled as handled by Nexum
		/*
		// NOTE: do not change wish list badge value in shop
		if (!isGiftFinderPage()) {
			return;
		}

		const $wishListQuantity = $("#Service-Navi_Wishlist").children(".qty-1");
		$wishListQuantity.text(value || "0");
		*/
	}

	/*
	function showWishListError(error) {
		window.EXWC.wishlist.displayErrorMessage(result.error);
	}
*/

	async function wait(timeout) {
		return new Promise((resolve) => {
			setTimeout(resolve, timeout);
		});
	}

	function navigateToUrl(url) {
		try {
			customDebugLog("calling callbackUrlRedirect with url: " + url);

			callbacks &&
				callbacks.callbackUrlRedirect &&
				callbacks.callbackUrlRedirect(url);
			window.EpoqNS.EventBus.$emit("epoqCloseGiftList");
		} catch (e) {
			customDebugLog("error during routing with url: " + url, e, 1);
		}
	}

	function getIconPath(icon) {
		return EpoqNS.getIconPath(icon);
	}

	function isMobileViewport() {
		return window.innerWidth < 768;
	}

	function triggerClubModal() {
		/*
		if (typeof $.fancybox === "undefined") {
			return;
		}

		$("#epoq-gift-list .triggerClubModal").fancybox({
			type: "ajax",
			autoHeight: true,
			fitToView: true,
			width: "470px",
			autoSize: false,
			closeClick: true,
			openEffect: "fade",
			closeEffect: "fade",
			padding: [30, 30, 5, 30] // [top, right, bottom, left]
		});
		*/
	}

	function addToCart(item) {
		customDebugLog("calling callbackAddToBasket with ean: " + item.productId);

		callbacks
			.callbackAddToBasket(item.productId, { sidebar: !isGiftFinderActive() })
			.then((result) => {
				customDebugLog("callbackAddToBasket result", result, 1);

				try {
					flowConfig.addToCart({
						productId: item.productId,
						unitPrice: item.price,
					});
				} catch (e) {
					Debug.log("error during GL addToCart", e, 1);
				}

				try {
					EpoqGF.epoq_checkBasketValues();
				} catch (e) {
					Debug.log("error during basket counter update", e, 1);
				}
			});
	}

	function handleShopAddToWishList() {
		$(document).off(
			"click.epoqGL",
			'[data-cy="wishlistSaveList"] li span, [data-cy="wishlistCreatenewForm"] button',
		);
		$(document).on(
			"click.epoqGL",
			'[data-cy="wishlistSaveList"] li span, [data-cy="wishlistCreatenewForm"] button',
			() => {
				window.setTimeout(() => {
					handleGiftList(false, true);
				}, 1500);
			},
		);
	}

	function handleShopRemoveFromWishList() {
		$(document).off(
			"mousedown.epoqGL",
			'[class*="WishlistOverviewStyled"] [class*="CloseButtonStyled"], [class*="TileEngineWrapper"] [class*="CloseButtonStyled"], [class*="ModalContentStyled"] button[type="submit"], [class*="WishListItemStyled"] button[type="submit"]',
			updateWishlistWithDelay,
		);
		$(document).on(
			"mousedown.epoqGL",
			'[class*="WishlistOverviewStyled"] [class*="CloseButtonStyled"], [class*="TileEngineWrapper"] [class*="CloseButtonStyled"], [class*="ModalContentStyled"] button[type="submit"], [class*="WishListItemStyled"] button[type="submit"]',
			updateWishlistWithDelay,
		);
		$(document).off(
			"keyup.epoqGL",
			'[class*="WishListItemStyled"] input[type="text"]',
		);
		$(document).on(
			"keyup.epoqGL",
			'[class*="WishListItemStyled"] input[type="text"]',
			(event) => {
				if (event.which === 13) {
					updateWishlistWithDelay();
				}
			},
		);
	}

	function updateWishlistWithDelay() {
		window.setTimeout(() => {
			handleGiftList(false);
		}, 1500);
	}

	/*
	function handleShopClearWishList() {
		$(document).off(
			"click.epoqGL",
			'[data-cy="modal-drop"] [class*="FormRowButtonsStyled"] button[type="submit"]'
		);
		$(document).on(
			"click.epoqGL",
			'[data-cy="modal-drop"] [class*="FormRowButtonsStyled"] button[type="submit"]',
			() => {
				window.setTimeout(() => {
					handleGiftList(false);
				}, 1000);
			}
		);
	}
*/

	function triggerRefreshGiftList(sync) {
		window.EpoqNS.EventBus.$emit("epoqRefreshGiftList", {
			giftList: giftListObj.giftList,
			sync: sync || false,
		});
		window.EpoqNS.EventBus.$emit("epoqUpdateGiftList", giftListObj.giftList);
	}

	function clearEcommerceObject() {
		window.dataLayer.push({
			event: "clearEcommerceObject",
			ecommerce: null,
		});
	}

	function initGiftList() {
		let target = document.createElement("DIV");
		target.id = "epoq-gift-list";

		if (!window.document.querySelector("#epoq-gift-list")) {
			window.document.body.appendChild(target);
		}

		Vue.config.productionTip = false;
		Vue.component("v-style", {
			render: function (createElement) {
				return createElement("style", this.$slots.default);
			},
		});

		new Vue({
			data: giftListObj,
			render: (h) => h(App),
		}).$mount("#epoq-gift-list");
	}
}

function setDegugMode() {
	const qs = window.location.search || "";

	if (
		qs.indexOf("epoqDebug") >= 0 ||
		qs.indexOf("epoqGiftlistDebug") >= 0 ||
		window.sessionStorage.getItem("epoqDebug") === "true"
	) {
		Debug.enable();
		Debug.setLogPrefix("epoqGIFTLIST");
	} else {
		Debug.disable();
	}
}

/* debugging console logs with date */
function customDebugLog(str, data, list) {
	window.EpoqNS.customDebugLog(str, "GIFTLIST", data || null, list || 0);
}
